// routes.js
import React from "react";
import { Route, Routes } from "react-router-dom";

// Pages
import Home from "../pages/Home";

// News
import NewsList from "../pages/NewsList";
import NewsItem from "../pages/NewsItem";

// Course
import CourseList from "../pages/CourseList";
import CourseItem from "../pages/CourseItem";
import CourseLessons from "../pages/CourseLessons";
import CourseStats from "../pages/CourseStats";

// Auth
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Settings from "../pages/Settings";
import NotFound from "../pages/404";
import DocumentList from "../pages/DocumentList";
import ShiftbatList from "../pages/ShiftbatsList";
import EmailConfirmation from "../pages/auth/EmailConfirmation";
import Shop from "../pages/Shop";
import Product from "../pages/Product";
import PostPurchase from "../pages/PostPurchase";
import Services from "../pages/Services";
import Bookings from "../pages/Bookings";
import JourneyPlanner from "../pages/JourneyPlanner";

const Router = () => {
    return (
        <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/:id" element={<NewsItem />} />
            <Route path="/documents" element={<DocumentList />} />
            <Route path="/shop/courses" element={<Shop />} />
            <Route path="/shop/courses/:id" element={<Product />} />
            <Route path="/shop/courses/:id" element={<Product />} />
            <Route path="/shop/:id/purchase" element={<PostPurchase />} />
            <Route path="/courses" element={<CourseList />} />
            <Route path="/courses/:id" element={<CourseItem />} />
            <Route path="/courses/:id/lessons" element={<CourseLessons />}/>
            <Route path="/courses/:id/stats" element={<CourseStats />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/driver-duties" element={<ShiftbatList />} />
            <Route path="/services" element={<Services />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/journey-planner" element={<JourneyPlanner />} />
            <Route path="/auth/email-confirmation" element={<EmailConfirmation />} />
        </Routes>
    );
};

export default Router;
